import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '../helpers/classnames'

export interface ListProps extends HTMLAttributes<HTMLUListElement> {
  spacing?: number
  styleType?: 'none' | 'disc' | 'decimal'
  stylePosition?: 'inside' | 'outside'
}

export const List = forwardRef<HTMLUListElement, ListProps>(
  ({ children, className, spacing = 2, styleType = 'none', stylePosition = 'outside', ...rest }, ref) => {
    const spacingClass = spacing ? `space-y-${spacing}` : ''
    const listStyleClass = {
      none: 'list-none',
      disc: 'list-disc',
      decimal: 'list-decimal'
    }[styleType]
    const positionClass = stylePosition === 'inside' ? 'list-inside' : 'list-outside'

    return (
      <ul
        ref={ref}
        className={cn(
          spacingClass,
          listStyleClass,
          positionClass,
          'pl-5',
          className
        )}
        {...rest}
      >
        {children}
      </ul>
    )
  }
)

List.displayName = 'List'

export interface ListItemProps extends HTMLAttributes<HTMLLIElement> {}

export const ListItem = forwardRef<HTMLLIElement, ListItemProps>(
  ({ children, className, ...rest }, ref) => {
    return (
      <li
        ref={ref}
        className={cn(className)}
        {...rest}
      >
        {children}
      </li>
    )
  }
)

ListItem.displayName = 'ListItem'